import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/Sidebar.css';
import logo from '../assets/logo.png';
import api from '../services/api';


function Sidebar() {
    const location = useLocation();
    const [cantiereId, setCantiereId] = useState(localStorage.getItem('idCantiere'));
    const [nomeCantiere, setNomeCantiere] = useState(localStorage.getItem('nomeCantiere'));

    useEffect(() => {
        setCantiereId(localStorage.getItem('idCantiere'));
        setNomeCantiere(localStorage.getItem('nomeCantiere'));
    }, [location]);

    const handleLogout = async (e) => {
        e.preventDefault();
        const ok = window.confirm("Vuoi davvero uscire?");
        if (!ok) return;

        try {
            await api.post('/logout'); // PHP distrugge la sessione
        } catch (err) {
            // anche se fallisce, forziamo comunque il logout client-side
            // console.debug('Logout errore:', err);
        } finally {
            // pulizia storage e redirect al login
            try {
                localStorage.clear();
            } catch (_) {}
            window.location.href = '/login';
        }
    };
    return (
        <div className="sidebar">
            {/* <h4 className="p-3">Kleos</h4> */}
            <div className="sidebar-header d-flex align-items-center flex-column px-3 mb-4">
                <img
                  src={logo}
                  alt="Kleos Logo"
                  className="sidebar-logo"
                />
                <div className="sidebar-title">
                    <strong>Progetto</strong><br />
                    <Link className="nav-link" to={`/dashboard/${cantiereId}`}> <span>{nomeCantiere || 'Cantiere'}</span></Link>
                </div>
            </div>
            <ul className="nav flex-column px-3">
                <li className="nav-item sidebar--nav-item">
                    <Link className="nav-link" to={`/dashboard/${cantiereId}`}>
                        <i className="bi bi-house-door me-2"></i>
                        <span className="link-text">Dashboard</span>
                    </Link>
                </li>
                <li className="nav-item sidebar--nav-item">
                    <Link className="nav-link" to={`/dashboard/${cantiereId}/vendite`}>
                        <i className="bi bi-bar-chart me-2"></i>
                        <span className="link-text">Vendite</span>
                    </Link>
                </li>
                <li className="nav-item sidebar--nav-item">
                    <Link className="nav-link" to={`/dashboard/${cantiereId}/budget`}>
                        <i className="bi bi-wallet2 me-2"></i>
                        <span className="link-text">Budget</span>
                    </Link>
                </li>
                {/* Altri link come Contatti, Fatture, ecc. */}
                <li className="nav-item sidebar--nav-item">
                    <Link className="nav-link" to={`/dashboard/${cantiereId}/contatti`}>
                        <i className="bi bi-people me-2"></i>
                        <span className="link-text">Contatti &amp; Lead</span>
                    </Link>
                </li>
                <li className="nav-item sidebar--nav-item">
                    <Link className="nav-link" to={`/dashboard/${cantiereId}/pagamenti`}>
                        <i className="bi bi-credit-card me-2"></i>
                        <span className="link-text">Pagamenti</span>
                    </Link>
                </li>
                <li className="nav-item sidebar--nav-item">
                    <Link className="nav-link" to={`/dashboard/${cantiereId}/fornitori`}>
                        <i className="bi bi-truck me-2"></i>
                        <span className="link-text">Fornitori</span>
                    </Link>
                </li>
                <li className="nav-item sidebar--nav-item">
                    <Link className="nav-link" to={`/`}>
                        <i className="bi bi-folder me-2"></i>
                        <span className="link-text">Progetti</span>
                    </Link>
                </li>
                <li className="nav-item sidebar--nav-item mt-3">
                    <a href="#logout" className="nav-link text-danger" onClick={handleLogout}>
                        <i className="bi bi-box-arrow-right me-2"></i>
                        <span className="link-text">Logout</span>
                    </a>
                </li>
            </ul>
        </div>
    );
}

export default Sidebar;
